export function getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return (
            error.message || "An unexpected error occurred. Please try again."
        );
    }

    // Handle other types of errors (e.g., strings or objects)
    if (typeof error === "string") {
        return error;
    }

    if (typeof error === "object" && error !== null && "message" in error) {
        return (error.message as string) || "An unknown error occurred.";
    }

    return "An unexpected error occurred. Please try again.";
}
